'use client';

import { useTranslations } from 'next-intl';
import { GenericDialog } from '~/components/commons/genericDialog/GenericDialog';
import { ErrorInfos } from '../../Error/ErrorInfos';
import { useApiErrorContext, useAuthenticatedContext } from '../../Provider';

export function LoginDialog() {
  const t = useTranslations('GLOBAL');

  const { redirectToLogin, revokeAuthentication, isAuthenticating } = useAuthenticatedContext();
  const { setError } = useApiErrorContext();

  const handleClose = async () => {
    await revokeAuthentication();
    setError(null);
  };

  return (
    <GenericDialog
      isOpen
      isClosable
      content={<ErrorInfos />}
      onClose={handleClose}
      primaryButtonTitle={t('LOGIN')}
      primaryButtonClick={async () => await redirectToLogin()}
      isPrimaryButtonDisabled={isAuthenticating}
      secondaryButtonTitle={t('LOGOUT')}
      secondaryButtonClick={handleClose}
    />
  );
}
